import React from 'react';
import {
  Container,
  ShapeDropdownMenu,
  ShapeDropdownContainer,
  ShapeOptionContainer,
  SelectedShapeContainer,
  FullLine,
  DashedLine,
} from './style';
import useWatchProp from 'hooks/use-watch-prop';
import { LinkType } from 'graphql/types';

export interface LinkLineShapeDropdownProps {
  selected: LinkType;
  color: string;
  onChange?: (shape: string) => void;
}

const SHAPE_MAP = {
  [LinkType.Full]: <FullLine />,
  [LinkType.Dashed]: <DashedLine />,
};

const defaultProps = {
  options: Object.values(SHAPE_MAP),
};

function LinkLineShapeDropdown({
  selected,
  color,
  onChange,
}: LinkLineShapeDropdownProps) {
  const [isDropdownVisible, setDropdownVisible] = React.useState<boolean>(
    false,
  );

  const [selectedShape, setSelectedShape] = React.useState<any>(selected);

  useWatchProp(selected, setSelectedShape);

  const SelectedShape = SHAPE_MAP[selectedShape] ?? null;

  React.useEffect(() => {
    return () => setDropdownVisible(false);
  }, []);

  function toggleDropdown() {
    setDropdownVisible(!isDropdownVisible);
  }

  function selectShape(shape: string): Function {
    return function () {
      setSelectedShape(shape);
      setDropdownVisible(false);
      onChange && onChange(shape);
    };
  }

  return (
    <Container>
      <SelectedShapeContainer onClick={toggleDropdown} color={color}>
        {SelectedShape}
      </SelectedShapeContainer>
      {isDropdownVisible && (
        <ShapeDropdownContainer>
          <ShapeDropdownMenu>
            {Object.entries(SHAPE_MAP).map(([value, shape]) => (
              <ShapeOptionContainer
                key={value}
                onClick={selectShape(value)}
                color={color}>
                {shape}
              </ShapeOptionContainer>
            ))}
          </ShapeDropdownMenu>
        </ShapeDropdownContainer>
      )}
    </Container>
  );
}

LinkLineShapeDropdown.defaultProps = defaultProps;

export default LinkLineShapeDropdown;
